import {dateFormatter, getLocale, MOMENTJS_DATE_FORMAT} from '@hconnect/uikit'
import moment from 'moment-timezone'

export function getTodayInTimezone(timezone: string): Date {
  return moment.tz(timezone).startOf('day').toDate()
}

export function getTodayISOInTimezone(timezone: string): string {
  return moment.tz(timezone).startOf('day').toISOString()
}

export function toISOStartOfDay(date: Date): string {
  return moment(date).startOf('day').toISOString()
}

export function formatISODateForDisplay(isoDate: string, timezone: string): string {
  const utcOffset = moment.tz(isoDate, timezone).utcOffset()
  return dateFormatter(isoDate, getLocale(), utcOffset)
}

export function subtractDaysFromISODate(isoDate: string, days: number): string {
  return moment(isoDate).subtract(days, 'days').startOf('day').toISOString()
}

export function localDateToISOInTimezone(localDate: string, timezone: string): string {
  return moment.tz(localDate, MOMENTJS_DATE_FORMAT, timezone).startOf('day').toISOString()
}

export function isoToLocalDateInTimezone(isoDate: string, timezone: string): string {
  return moment.tz(isoDate, timezone).format(MOMENTJS_DATE_FORMAT)
}

export function compareDateStrings(date1: string, date2: string): number {
  const m1 = moment(date1).startOf('day')
  const m2 = moment(date2).startOf('day')

  if (m1.isBefore(m2)) return -1
  if (m1.isAfter(m2)) return 1
  return 0
}

export function isFutureDate(isoDate: string, timezone: string): boolean {
  const today = getTodayISOInTimezone(timezone)
  return compareDateStrings(isoDate, today) > 0
}

export function isNewTarget(targetId: string): boolean {
  return /^\d+$/.test(targetId)
}

export function canModifyTarget(targetId: string, validFrom: string, timezone: string): boolean {
  if (isNewTarget(targetId)) {
    return true
  }

  return isFutureDate(validFrom, timezone)
}
